import * as React from 'react';

import { ProductCardModel, ProductTileModel } from '@notino/react-styleguide';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { noop } from '@utils/noop';

import { IProductItemProps } from './model';
import { StyledProductCard, StyledProductTile } from './styled';
import { useProductItemProps } from './useGetProductItemProps';

export const ProductItem: React.FC<IProductItemProps> = React.memo(
  ({
    columns,
    innerRef,
    onProductAdded = noop,
    onProductAddFailed = noop,
    onClosingCartModal = noop,
    setProductWishlisted,
    sendGTM = false,
    useMasterUrl = false,
    showBuyButton = false,
    showWishlistButton = true,
    position = 0,
    inSectionOfType = '',
    appendComponent = null,
    showAddToCartModal = true,
    canSpaRedirect = true,
    ...rest
  }) => {
    const { release_discovery_product_card_2026 } = useFeatureFlags();

    const productProps = useProductItemProps({
      useMasterUrl,
      inSectionOfType,
      sendGTM,
      canSpaRedirect,
      setProductWishlisted,
      onProductAdded,
      onProductAddFailed,
      onClosingCartModal,
      showBuyButton,
      showWishlistButton,
      showAddToCartModal,
      position,
      appendComponent,
      ...rest,
    });

    if (!productProps) {
      return null;
    }

    if (release_discovery_product_card_2026) {
      return (
        <StyledProductCard
          data-testid="product-item"
          columns={columns}
          ref={innerRef as React.Ref<HTMLDivElement>}
          data-cypress="productItem-container"
          productProps={
            productProps as ProductCardModel.IProductCardContentProps
          }
        />
      );
    }

    return (
      <StyledProductTile
        data-testid="product-item"
        columns={columns}
        ref={innerRef as React.Ref<HTMLDivElement>}
        data-cypress="productItem-container"
        productProps={productProps as ProductTileModel.IProductTileContentProps}
      />
    );
  }
);

export default ProductItem;
